query InvitationStatisticsForCompany($isMasterView: Boolean, $childCompanyId: ID) {
  invitationStatisticsForCompany(isMasterView: $isMasterView, childCompanyId: $childCompanyId) {
    conversions
    total
    invitationsPerLandingpage {
      conversions
      landingpageSlug
      landingpageName
      total
    }
  }
}
